export default __webpack_public_path__ + "static/media/cad2.48642eaf.png";